import { ChevronRight } from 'lucide-react';

const Cities = () => {
  const cities = [
    {
      name: 'Lagos',
      image: 'https://images.unsplash.com/photo-1719314073622-9399d167725b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsYWdvcyUyMG5pZ2VyaWElMjBza3lsaW5lfGVufDB8fHx8MTc3NDUyNTE1OHww&ixlib=rb-4.1.0&q=85',
      available: true
    },
    {
      name: 'Abuja',
      image: 'https://images.pexels.com/photos/36647531/pexels-photo-36647531.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      available: true
    },
    {
      name: 'Ibadan',
      image: 'https://images.unsplash.com/photo-1719314073622-9399d167725b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsYWdvcyUyMG5pZ2VyaWElMjBza3lsaW5lfGVufDB8fHx8MTc3NDUyNTE1OHww&ixlib=rb-4.1.0&q=85',
      available: true
    },
    {
      name: 'Port Harcourt',
      image: 'https://images.unsplash.com/photo-1719314073622-9399d167725b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsYWdvcyUyMG5pZ2VyaWElMjBza3lsaW5lfGVufDB8fHx8MTc3NDUyNTE1OHww&ixlib=rb-4.1.0&q=85',
      available: true
    },
    {
      name: 'Kano',
      image: 'https://images.unsplash.com/photo-1719314073622-9399d167725b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsYWdvcyUyMG5pZ2VyaWElMjBza3lsaW5lfGVufDB8fHx8MTc3NDUyNTE1OHww&ixlib=rb-4.1.0&q=85',
      available: true
    },
    {
      name: 'Enugu',
      image: 'https://images.unsplash.com/photo-1719314073622-9399d167725b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsYWdvcyUyMG5pZ2VyaWElMjBza3lsaW5lfGVufDB8fHx8MTc3NDUyNTE1OHww&ixlib=rb-4.1.0&q=85',
      available: true
    },
    {
      name: 'Benin City',
      image: 'https://images.unsplash.com/photo-1719314073622-9399d167725b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsYWdvcyUyMG5pZ2VyaWElMjBza3lsaW5lfGVufDB8fHx8MTc3NDUyNTE1OHww&ixlib=rb-4.1.0&q=85',
      available: true
    },
    {
      name: 'Calabar',
      image: 'https://images.unsplash.com/photo-1719314073622-9399d167725b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsYWdvcyUyMG5pZ2VyaWElMjBza3lsaW5lfGVufDB8fHx8MTc3NDUyNTE1OHww&ixlib=rb-4.1.0&q=85',
      available: false
    }
  ];

  return (
    <section id="cities" data-testid="cities-section" className="section bg-[var(--bg-primary)] dark:bg-[#111111]">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[var(--text-primary)] mb-4" data-testid="cities-heading">
            Now available in
          </h2>
          <p className="text-base text-[var(--text-secondary)] leading-relaxed">
            We're expanding across Nigeria. Book a barber in your city today.
          </p>
        </div>

        {/* Cities Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="cities-grid">
          {cities.map((city, index) => (
            <div
              key={index}
              data-testid={`city-card-${city.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="group relative h-48 rounded-lg overflow-hidden cursor-pointer"
            >
              {/* City Image */}
              <img
                src={city.image}
                alt={city.name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>

              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-bold text-white mb-1">{city.name}</h3>
                    {city.available ? (
                      <span className="text-xs text-[#00C167] font-semibold">Available now</span>
                    ) : (
                      <span className="text-xs text-gray-400 font-semibold">Coming soon</span>
                    )}
                  </div>
                  {city.available && (
                    <ChevronRight className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                  )}
                </div>
              </div>

              {/* Hover Border */}
              {city.available && (
                <div className="absolute inset-0 border-2 border-[#00C167] opacity-0 group-hover:opacity-100 transition-opacity rounded-lg"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cities;